module.exports = __webpack_public_path__ + "static/media/WM.fa08ede1.png";